import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import log from 'loglevel';

const SummaryMarkup = (data) => {
  let frontmatter;
  try {
    frontmatter = data.data.node.frontmatter;
  } catch (err) {
    console.error({ data }, 'got bum data!');
    throw err;
  }
  log.debug({ data }, 'summaryMarkup');
  return (
    <div className="faimly--summary">
      <MDXRenderer>{data.data.node.body}</MDXRenderer>
    </div>
  );
};

const FamilySummary = (props) => {
  const data = useStaticQuery(graphql`
    query FamilySummary {
      allMdx(filter: { fileAbsolutePath: { regex: "/content/families/" } }) {
        edges {
          node {
            body
            frontmatter {
              family
            }
          }
        }
      }
    }
  `);
  let summary;
  if (data) {
    for (const item of data.allMdx.edges) {
      if (
        item.node.frontmatter.family.toLowerCase() ===
        props.family.toLowerCase()
      ) {
        summary = item;
      }
    }
  }
  if (data && !summary) {
    return undefined;
  }

  return <SummaryMarkup data={summary} />;
};

export default FamilySummary;
